// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { recentNavWishListsStyles } from "@pace/App/Widgets/MyAccount/NavWishLists";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

recentNavWishListsStyles.gridContainer = {
    gap: 10,
};
recentNavWishListsStyles.spinnerGridItem = {
    width: 12,
    css: css`
        justify-content: center;
        align-items: center;
    `,
};
recentNavWishListsStyles.wishListCardGridItem = {
    width: 12,
    css: css`
        padding: 0 5px;
        ${StyledButton} {
            font-size: 14px;
            padding: 7px 8px;
            letter-spacing: 0;
            line-height: 22px;
            width: 100%;
            &:hover {
                color: ${color("primary.main")};
                background-color: ${color("common.ui11")};
            }
        }
    `,
};
recentNavWishListsStyles.notify = {
    css: css`
        min-width: unset;
        width: 100%;
        margin: 0 8px;
    `,
};
recentNavWishListsStyles.title = {
    variant: "h5",
    css: css`
        padding: 0 9px;
        margin-bottom: 8px;
        width: 100%;
    `,
};
